import { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useCreateLiveStreamPostMutation = createMutationHook(
  MembershipsCreatorV2ApiClient.createLiveStreamPost,
  {
    mutationKey: ['createLiveStreamPost'],
  },
)
